import { render, staticRenderFns } from "./cabinet-accounting-details.vue?vue&type=template&id=2fb65102&scoped=true&"
import script from "./cabinet-accounting-details.vue?vue&type=script&lang=js&"
export * from "./cabinet-accounting-details.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-accounting-details.vue?vue&type=style&index=0&id=2fb65102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb65102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fb65102')) {
      api.createRecord('2fb65102', component.options)
    } else {
      api.reload('2fb65102', component.options)
    }
    module.hot.accept("./cabinet-accounting-details.vue?vue&type=template&id=2fb65102&scoped=true&", function () {
      api.rerender('2fb65102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/accounting/cabinet-accounting-details.vue"
export default component.exports